import Image from "next/image";
import * as S from "./styles.ts";
import RatingStar from "@/lib/images/about/RatingStars.png";
export interface IReviewCard {
  author: string;
  review: string;
}

const ReviewCard = ({ author, review }: IReviewCard) => {
  return (
    <S.CustomerReviewCard>
      <p>{author}</p>
      <S.CustomerRating>
        <Image
          src={RatingStar}
          alt={"5 star phone system reviews"}
          height={0}
          width={132}
          style={{
            objectFit: "contain",
          }}
        />
      </S.CustomerRating>
      <S.CustomerReview>{review}</S.CustomerReview>
    </S.CustomerReviewCard>
  );
};

export default ReviewCard;
